import { createFetcher } from '../../Common';

import { getBaseUrl, ORGANIZATION_ENDPOINT, orgToken } from '../../constants';

export class Organization {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Organization(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = ORGANIZATION_ENDPOINT;
    this.fetcher = fetcher;
    this.token = orgToken;
  }

  get base_url() {
    return getBaseUrl();
  }

  async switchOrganization(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.sendPrivateRequest(url, {
      method: 'POST',
      body: JSON.stringify(reqBody),
    });

    return response?.data;
  }

  async postRefreshCall(reqBody) {
    const response = await this.fetcher.tenantRefresh(reqBody);
    return response;
  }
}

export const createOrg = () => Organization.getInstance();
